/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react'


class MainItemList extends React.Component {

    render() {
        return (
            <div className="mainpage-item-list">
                {this.props.children}
            </div>
        )
    }
}

export default MainItemList


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/MainItemList.js